export class Setting {
  id : any;
  id_utente: any;
  id_timesheet: any;
  destinatari: any;
  ore_timesheet: any;
  email: any;
}
